var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReplyInThread(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Base_Icon"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3985_363515",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    x: 0.00390625,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3985_363515)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "subdirectory_arrow_right",
    d: "M13.4769 19.9578C13.3219 19.8026 13.246 19.6253 13.2492 19.426C13.2523 19.2267 13.3282 19.0526 13.4769 18.9038L16.6309 15.75H7.31166C6.81299 15.75 6.38699 15.5734 6.03366 15.2203C5.68049 14.8669 5.50391 14.4409 5.50391 13.9423V5.25C5.50391 5.03717 5.57574 4.859 5.71941 4.7155C5.86291 4.57183 6.04107 4.5 6.25391 4.5C6.46674 4.5 6.64491 4.57183 6.78841 4.7155C6.93207 4.859 7.00391 5.03717 7.00391 5.25V13.9423C7.00391 14.0321 7.03274 14.1058 7.09041 14.1635C7.14807 14.2212 7.22182 14.25 7.31166 14.25H16.6309L13.4617 11.0807C13.3065 10.9256 13.2315 10.7499 13.2367 10.5538C13.2418 10.3578 13.3168 10.1822 13.4617 10.027C13.6168 9.87183 13.7941 9.79333 13.9934 9.7915C14.1927 9.7895 14.3667 9.86283 14.5154 10.0115L18.8712 14.3673C18.9648 14.4609 19.0308 14.5597 19.0692 14.6635C19.1077 14.7673 19.1269 14.8795 19.1269 15C19.1269 15.1205 19.1077 15.2327 19.0692 15.3365C19.0308 15.4403 18.9648 15.5391 18.8712 15.6328L14.5462 19.9578C14.391 20.1128 14.2128 20.1902 14.0117 20.1902C13.8103 20.1902 13.6321 20.1128 13.4769 19.9578Z",
    fill: "#A1A1A1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReplyInThread);
export default __webpack_public_path__ + "static/media/reply_in_thread.c2438eebbf3689267cbca6d1fb2078bf.svg";
export { ForwardRef as ReactComponent };